import React, { useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useI18n } from '@shopify/react-i18n';
import enTranslations from './translations/en.json';
import frTranslations from './translations/fr.json';

const translationsByLocale = { en: enTranslations, fr: frTranslations };

export default function AppShell({ children }) {
  const navigate = useNavigate();
  const location = useLocation();

  const [i18n] = useI18n({
    id: 'AppShell',
    fallback: enTranslations,
    translations(locale) {
      return translationsByLocale[locale] ?? enTranslations;
    },
  });

  const navItems = useMemo(
    () => [
      { route: '/', label: i18n.translate('AppShell.nav.dashboard'), icon: 'gauge' },
      { route: '/feed', label: i18n.translate('AppShell.nav.feed'), icon: 'product-list' },
      { route: '/tracking', label: i18n.translate('AppShell.nav.tracking'), icon: 'order-fulfilled' },
    ],
    [i18n]
  );

  const isMainActive = ({ route }) => {
    if (route === '/') return location.pathname === '/';
    return location.pathname === route || location.pathname.startsWith(route + '/');
  };

  return (
    <>
      <style>{`
        .appshell-nav {
          overflow-x: auto;
          -webkit-overflow-scrolling: touch;
        }
        .appshell-nav-inner {
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          gap: 8px;
        }
        @media (min-width: 769px) {
          .appshell-nav-inner {
            justify-content: center;
          }
        }
      `}</style>
      <div className="appshell-nav">
        <div className="appshell-nav-inner">
          {navItems.map((item) => (
            <s-button
              key={item.route}
              variant={isMainActive(item) ? 'primary' : 'secondary'}
              icon={item.icon}
              onClick={() => navigate(item.route)}
            >
              {item.label}
            </s-button>
          ))}
        </div>
      </div>

      {children}
    </>
  );
}
